/*! @azure/msal-react v3.0.13 2025-06-18 */
'use strict';
/* eslint-disable header/header */
const name = "@azure/msal-react";
const version = "3.0.13";

export { name, version };
//# sourceMappingURL=packageMetadata.js.map
